import { render, staticRenderFns } from "./page3.vue?vue&type=template&id=753a7b7e&scoped=true&"
import script from "./page3.vue?vue&type=script&lang=ts&"
export * from "./page3.vue?vue&type=script&lang=ts&"
import style0 from "./page3.vue?vue&type=style&index=0&id=753a7b7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753a7b7e",
  null
  
)

export default component.exports